import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IBadge } from './badge.interface';

@Component({
    selector: 'mlp-ng-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class BadgeSharedComponent {
    @Input() badge: IBadge;
}
